var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{staticClass:"box",style:({
      top: `${_vm.top}px`,
      left: `${_vm.left}px`,
      width: `${_vm.width}px`,
      height: `${_vm.height}px`,
    }),on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout}},[_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-error"})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }